import { isValidElement } from 'react';
import { isArrayLike } from 'mobx';
export default function isReactChildren(element) {
    if (element) {
        if (isArrayLike(element)) {
            return element.some(isReactChildren);
        }
        return isValidElement(element);
    }
    return false;
}
